import i18next from 'i18next'
import translationsObject from '@app/locales'

const checkForMezzoErrors = (key) => {
  const pattern = /mezzo_error_codes/
  return pattern.test(key)
}

// Flatten nested translation object into dot-notation keys for i18next
const flattenTranslations = (obj, prefix = '') => {
  const result = {}
  Object.keys(obj).forEach((key) => {
    const fullKey = prefix ? `${prefix}.${key}` : key
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(result, flattenTranslations(obj[key], fullKey))
    } else {
      result[fullKey] = obj[key]
    }
  })
  return result
}

i18next.init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    prefix: '%{',
    suffix: '}',
    escapeValue: false,
  },
  resources: {
    en: {
      translation: flattenTranslations(translationsObject.en),
    },
  },
  keySeparator: false,
  nsSeparator: false,
  parseMissingKeyHandler: (key) => {
    if (checkForMezzoErrors(key)) {
      return `${i18next.t('mezzo_error_codes.unknown_error_type')}`.replace('%d', key.match(/\d+/))
    }
    return `Missing translation: ${key}`
  },
})

// Compatibility wrapper matching react-redux-i18n API
const I18n = {
  t: (key, opts) => i18next.t(key, opts),
  setHandleMissingTranslation: () => {}, // no-op, handled via parseMissingKeyHandler
}

const configureLocales = () => {
  global.I18n = I18n
}

export default configureLocales
